import React from 'react';
import classnames from 'classnames';
import PageNavigation from '../PageNavigation';
import QuestionGroups from '@ignitesales/neuro-application/src/components/questions/QuestionGroups';
import PerfectScrollbar from "react-perfect-scrollbar";
import {notifyValidationErrors} from "../Notifications";

const SurveyPageConnected = ({classname, currentPage, nextPageClicked, previousPageClicked, validationErrors = [], processingNavigation}) => {
  const cssBEM = 'surveyPage';
  const classes = classnames(
    cssBEM,
    `surveyPage--path-${currentPage.path.key}`,
    `surveyPage--page-${currentPage.page.key}`,
    classname
  );

  const onDisabledClick = (action) => {
    if (!action.isReverse) {
      notifyValidationErrors(validationErrors)
    }
  };

  return (
    <div className={classes}>
      <div className={`${cssBEM}__container container`}>
        <div className={`${cssBEM}__question-box`}/>
        <div className={`${cssBEM}__questions`}>
          <div className={`${cssBEM}__questionGroups questionGroups`}>
            <PerfectScrollbar>
              <QuestionGroups currentPage={currentPage} validationErrors={validationErrors}/>
            </PerfectScrollbar>
          </div>
          <div className={`${cssBEM}__divider`} />
          <PageNavigation
            nextPageClicked={nextPageClicked}
            previousPageClicked={previousPageClicked}
            disableForwardNavigation={validationErrors.length > 0}
            processingNavigation={processingNavigation}
            onDisabledClick={onDisabledClick}
          />
        </div>
      </div>
    </div>
  );
};

export default SurveyPageConnected;
